import styled from 'styled-components'

export const Container = styled.div`
	form {
		display: grid !important;
		grid-template-columns: 0.5fr 0.5fr 1fr 280px;
		grid-template-areas: 
			'mes ano numero card'
			'titular titular cvv card'
			'termo termo termo termo'
			'check check check check'
			'button button button button';

		.field.calendar,
		.field.textbox {
			width: calc(100% - 16px) !important;
		}

		.field.checkbox {
			width: calc(100% - 16px) !important;
			grid-area: check;
		}

		.credit-card {
			grid-area: card;
			justify-content: start;
		}

		.field.select {
			width: calc(100% - 16px) !important;
		}

		@media(max-width: 1000px) {
			grid-template-columns: 0.5fr 0.5fr 1fr;
			grid-template-areas: 
				'card card'
				'mes ano numero'
				'titular titular cvv'
				'termo termo termo'
				'check check check'
				'button button button';

			.credit-card {
				grid-area: card;
				justify-content: center;
			}
		}

		@media(max-width: 850px) {
			grid-template-columns: 1fr;
			grid-template-areas: 
				'card'
				'mes'
				'ano'
				'numero'
				'titular'
				'cvv'
				'termo'
				'check'
				'button';
		}
	}
`

export const TermoContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	grid-area: termo;
`

export const ModalTermoContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;

	iframe {
		width: calc(100% - 16px);
		height: 80vh;
	}
`
